package com.eladfinish.bible.contest.screens.search.usecases

import com.eladfinish.bible.contest.data.common.AssetReader
import com.eladfinish.bible.contest.extensions.end
import com.eladfinish.bible.contest.extensions.start
import com.eladfinish.bible.contest.models.ClickableArea
import com.eladfinish.bible.contest.models.ClickableTextData

class LinkToExamplesUseCase(
    private val assetReader: AssetReader,
) {

    fun getSearchHelpContent(
        onSearchExampleClicked: (String) -> Unit,
        debugFlag: Boolean,
    ): ClickableTextData {
        val searchGuide = assetReader.readFile("other" + assetReader.fileSeparator + "searchGuide.txt")
        return clickableTextData(searchGuide, onSearchExampleClicked, debugFlag)
    }

}

fun clickableTextData(
    searchGuide: String,
    onSearchExampleClicked: (String) -> Unit,
    debugFlag: Boolean,
): ClickableTextData {
    val stringBuilder = StringBuilder(searchGuide)
    val sbDebug = StringBuilder("")

    // LL - boundaries of an expression which has to be spanned. L-link
    // LישראלL
    // ישראל
    val regexLL = "L(.*?)L"
    val clickableAreas = mutableListOf<ClickableArea>()

    regexLL.toRegex().findAll(searchGuide).forEachIndexed { index, matchResult ->
        val clickableText = matchResult.groups[1]?.value
        sbDebug.append("${index.plus(1)}. ").append(clickableText).append("\n")
        // on each iteration we delete the L...L boundaries (2 characters)
        val offset = 2 * index
        clickableAreas.add(
            ClickableArea(
                start = matchResult.start - offset,
                end = matchResult.end - offset - 2, // after removing L...L, 'end' index is shifted 2 places backward
                name = {
                    onSearchExampleClicked.invoke(clickableText.orEmpty())
                },
            )
        )
        stringBuilder.deleteAt(matchResult.start - offset)
        stringBuilder.deleteAt(matchResult.end - offset - 2)
    }

    if (debugFlag) {
        stringBuilder
            .append("\n\n")
            .append("כל הדוגמאות ברצף:")
            .append("\n")
            .append(sbDebug)
    }

    return ClickableTextData(
        text = stringBuilder.toString(),
        clickableAreas = clickableAreas,
    )
}
